import { CLOSE_MASK, OPEN_MASK, SET_SSO } from '../../constant';

const initState = sessionStorage.getItem('SSO_STATUS') === 'true';

const ssoReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_SSO:
      sessionStorage.setItem('SSO_STATUS', payload);
      return payload;
    case 'NO_ACTION':
      return state;
    default:
      return state;
  }
};

const maskReducer = (state = false, action) => {
  const { type } = action;
  switch (type) {
    case OPEN_MASK:
      return true;
    case CLOSE_MASK:
      return false;
    default:
      return state;
  }
};

export { ssoReducer, maskReducer };
